module.exports = __webpack_public_path__ + "img/report.0a0e6478.svg";